export default "__VITE_ASSET__KCh_m8VA__"